import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, Save } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ReportBuilder } from '@/components/manufacturing/ReportBuilder';
import { toast } from '@/hooks/use-toast';

export default function CreateProductionReport() {
  const navigate = useNavigate();

  const handleSave = async (report: any) => {
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      console.log('Creating report:', report);
      
      toast({
        title: 'Report Created',
        description: `Report "${report.name}" has been created successfully.`,
      });
      
      // Navigate to reports list
      navigate('/manufacturing/reports');
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to create report. Please try again.',
        variant: 'destructive',
      });
    }
  };

  const handlePreview = (report: any) => {
    // Open preview in a new window or modal
    console.log('Previewing report:', report);
    
    toast({
      title: 'Report Preview',
      description: 'Report preview functionality would open here.',
    });
  };

  return (
    <div className="container mx-auto py-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/manufacturing/reports')}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Reports
          </Button>
          <div>
            <h1 className="text-2xl font-bold">Create Production Report</h1>
            <p className="text-gray-600">
              Build custom reports with drag-and-drop interface
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-gray-500" />
          <span className="text-sm text-gray-500">
            Report Builder
          </span>
        </div>
      </div>

      {/* Report Builder */}
      <ReportBuilder
        onSave={handleSave}
        onPreview={handlePreview}
      />
    </div>
  );
} 